/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { ButtonPrimary } from "../../../components/NewButtons";
import { CreateProductDrawer } from "./CreateProductDrawer";
import { localStorageScrollPositionName } from "../ProductsList";

export const CreateProductSelector = () => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonPrimary
        height="100%"
        onClick={() => {
          setModalOpen(true);
          if (localStorage) {
            localStorage.removeItem(localStorageScrollPositionName);
          }
        }}
        type="button"
      >
        Create product
      </ButtonPrimary>
      <CreateProductDrawer
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
};
